import React from "react";

import styled from "styled-components";

import { RuleDesignerRender, RuleToolbarRender } from "../../DesignUI/CommonStyles";

import { Notification } from "../../../CommonUI/BuilderUI/Notification";

import { LinkingDataDialog } from "../../DesignUI/LinkingDataDialog";
import { StatementRuleEditContext } from "../StatementRuleEditContext";

import { DataTypePicker } from "../../../CommonUI/DataTypePicker/DataTypePicker";
import { IDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/IDataDefinition";
import { ExpressionBuilder } from "../../../Expressions/ExpressionBuilder";
import { StateManager } from "../../../rule-engine-core/Common/StateManager";
import { ObserveState } from "../../../CommonUI/StateManagement/ObserveState";
import { StatementRuleConfiguration } from "../../../rule-engine-core/Rule/Statement/StatementRuleConfiguration";
import { UIStyleConstants } from "../../../rule-engine-core/Common/UIStyleConstants";

interface IStatementRuleDesigner {
    editContext: StatementRuleEditContext;
    ruleDefinition: StatementRuleConfiguration;
}

export const StatementRuleDesigner = (props: IStatementRuleDesigner) => {
    const { ruleDefinition, editContext } = props;

    return (
        <RuleDesignerRender>
            <RuleToolbarRender>
                <DataTypePicker
                    variant={"header"}
                    dataDef={ruleDefinition.getRuleResult()}
                    readonly={!ruleDefinition.canChangeOutputs}
                    width={"150px"}
                    label={"Result:"}
                    updateCallback={(newType: IDataDefinition) => {
                        ruleDefinition.executionResult = newType;
                        StateManager.propertyChanged(ruleDefinition, "executionResult");
                    }}
                />
            </RuleToolbarRender>
            <RuleEditorWrapper>
                <RuleEditorRender>
                    <ObserveState
                        listenTo={ruleDefinition}
                        control={() => (
                            <ExpressionBuilder
                                expression={ruleDefinition.expression}
                                onUpdate={() => {
                                    StateManager.propertyChanged(ruleDefinition, "expression");
                                }}
                            />
                        )}
                        properties={["executionResult"]}
                    />
                </RuleEditorRender>
            </RuleEditorWrapper>

            <Notification editContext={editContext} />

            <LinkingDataDialog editContext={editContext} />
        </RuleDesignerRender>
    );
};

const RuleEditorWrapper = styled.div`
    padding: 16px 24px;
    flex: 1;
`;

const RuleEditorRender = styled.div`
    background: ${UIStyleConstants.WHITE_COLOR};
    border-radius: 4px;
    padding: 16px 24px;
    width: 800px;
    height: 100%;
`;
